import { map, startWith, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Component, Input,  EventEmitter, Output, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs-compat/Observable';
import { AppUser } from '../models/AppUser';
import { CreateKaizen } from '../models/Kaizen';
import { CompanyPerson } from '../models/CompanyPerson';
import { CompanyPersonService } from '../Services/CompanyPerson.Services';
import { ProjectTypeService } from '../Services/ProjectType.Service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: false
})
export class ContactComponent implements OnChanges {
  CreateKaizenContact: CreateKaizen = new CreateKaizen();
  @Input() CreateKaizen: CreateKaizen = new CreateKaizen();
  @Output() emitKaizenContact: EventEmitter<CreateKaizen> = new EventEmitter<CreateKaizen>();
  supportingMembers: string[] = [];
  kaizenCreatorControl = new UntypedFormControl();
  kaizenLeaderControl = new UntypedFormControl();
  kaizenSupporterControl = new UntypedFormControl();
  filteredKaizenCreator!: Observable<any>;
  filteredKaizenLeader!: Observable<AppUser[]>;
  formContact!: UntypedFormGroup;
  requiredLegend: string = '* = required field';
  kaizenId: number = 0;
  kaizenCreatorValid: boolean = true;
  kaizenLeaderValid: boolean = false;
  
  constructor(private formBuilder: UntypedFormBuilder, private CompanyPersonService: CompanyPersonService, private ProjectTypeService: ProjectTypeService,private route: ActivatedRoute) {
    this.filteredKaizenCreator = this.kaizenCreatorControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        return this.filter((val || ''), '', '')
      })
    );
    this.filteredKaizenLeader = this.kaizenLeaderControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        return this.filter((val || ''), '', '')
      })
    );
  }
  ngOnChanges(): void {
    this.kaizenId = Number(this.route.snapshot.paramMap.get('id'));
    this.formContact = this.formBuilder.group({
      kaizenCreatorControl: [''],
      kaizenLeaderControl: [''],
      kaizenSupporterControl: ['']
    });
    this.waitForInputValue().then(() => {
      if (this.kaizenId == 0) {
        const userEmail = localStorage.getItem(`userEmail`);
        const companyId = localStorage.getItem('companyId');
        this.kaizenCreatorControl.setValue(userEmail);
        this.kaizenCreatorValid = true;
        this.CreateKaizen.kaizenCreatorValid = true;
        //Added check to only set if the control value is null or empty string because after setting Leader this gets called again somewhere
        //and it resets the leader to the email address of the user.
        if (companyId !== '1' && (this.kaizenLeaderControl.getRawValue() == null || this.kaizenLeaderControl.getRawValue() == '')) {
          this.kaizenLeaderControl.setValue(userEmail);
          this.kaizenLeaderValid = true;
          this.CreateKaizen.kaizenLeaderValid = true;
        }
      }
      else {
        this.kaizenCreatorControl.setValue(this.CreateKaizen.kaizenCreator);
        this.kaizenCreatorValid = true;
        this.CreateKaizen.kaizenCreatorValid = true;
        this.kaizenLeaderControl.setValue(this.CreateKaizen.kaizenLeader);
        this.kaizenLeaderValid = true;
        this.CreateKaizen.kaizenLeaderValid = true;
      }
      this.supportingMembers = this.CreateKaizen.kaizenSupportingPerson;
    });


    this.CreateKaizenContact.kaizenCreator = this.CreateKaizen.kaizenCreator;
    this.CreateKaizenContact.kaizenLeader = this.CreateKaizen.kaizenLeader;
    if(this.CreateKaizen.kaizenSupportingPerson)
    {
      this.CreateKaizenContact.kaizenSupportingPerson = this.CreateKaizen.kaizenSupportingPerson;
    }
    else
    {
      this.CreateKaizenContact.kaizenSupportingPerson = [];
    }

    this.kaizenCreatorControl.valueChanges.subscribe((kCreator: string) => {
      
      this.CreateKaizenContact.kaizenCreator = kCreator;
     //if the string ends in .com then it is a complete email so see if it is a valid company person record
     if(kCreator && kCreator.substring(kCreator.length-4).toLocaleLowerCase() == '.com')
      {
        this.CompanyPersonService.gerCompanyPersonByEmail(kCreator).subscribe(result=>
          {
            if(!result)
            {
              this.CreateKaizenContact.kaizenCreatorValid = false;
              this.kaizenCreatorValid = false;
            }
            else
            {
              this.CreateKaizenContact.kaizenCreatorValid = true;
              this.kaizenCreatorValid = true;
              this.emitContact();
            }
            console.log("CompanyService Record" + result);

          });
      }
    });
    this.kaizenLeaderControl.valueChanges.subscribe((kLeader: string) => 
    {
      this.CreateKaizenContact.kaizenLeader = kLeader;
      //if the string ends in .com then it is a complete email so see if it is a valid company person record
      if(kLeader && kLeader.substring(kLeader.length-4).toLocaleLowerCase() == '.com')
      {
        this.CompanyPersonService.gerCompanyPersonByEmail(kLeader).subscribe(result=>
          {
            if(!result)
            {
              this.CreateKaizenContact.kaizenLeaderValid = false;
              this.kaizenLeaderValid = false;
            }
            else
            {
              this.CreateKaizenContact.kaizenLeaderValid = true;
              this.kaizenLeaderValid = true;
              this.emitContact();
            }
            console.log("CompanyService Record" + result);

          });
      }
      
    });
  }

  waitForInputValue(): Promise<any> {
    return new Promise((resolve) => {
      if (this.CreateKaizen) {
        resolve(this.CreateKaizen);
      }
    });
  }
  removeSupportingMember(index: number): void {
    this.supportingMembers.splice(index, 1);
  }
  addSupportingMember(): void {
    if (this.supportingMembers == undefined) {
      this.supportingMembers = [];
    }
    if (this.supportingMembers.length <= 5) {
      if(this.kaizenSupporterControl.value)
        {
          this.supportingMembers.push(this.kaizenSupporterControl.value);
          this.CreateKaizenContact.kaizenSupportingPerson = this.supportingMembers;
          this.emitContact();
          this.kaizenSupporterControl.reset();
        }
    }
  }

  filter(val: string, kaizenCreatorEmailId: string, kaizenLeaderEmailId: string): Observable<CompanyPerson[]> {
    return this.CompanyPersonService.getCompanyPerson(val, kaizenCreatorEmailId, kaizenLeaderEmailId)
      .pipe(map(response => response.data.filter(option => {
                return option.emailId.toLocaleLowerCase().indexOf(val.toLowerCase()) === 0
              }))
      )
  }  

  emitContact() 
  {
    this.emitKaizenContact.emit(this.CreateKaizenContact);
  }
}